/*!

=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

import api from "services/api";
import appVersion from "appVersion.json";

//====== WR data 06/10/2026 — pedido do usuário: mostrar no rodapé a versão do Front e do Back que
// estão no ar (W + data do build + commit), pra confirmar se um deploy realmente subiu. Front vem
// do appVersion.json gerado no build (scripts/genVersion.js); Back, de GET /api/app-version.
class Calendar extends React.Component {
  state = { backVersion: null, backCommit: null };

  componentDidMount() {
    api
      .get("/app-version")
      .then(({ data }) => this.setState({ backVersion: data?.versao || null, backCommit: data?.commit || null }))
      .catch(() => this.setState({ backVersion: null }));
  }

  render() {
    return (
      <>
        <Container fluid>
          <footer className="footer pt-0">
            <Row className="align-items-center justify-content-lg-between">
              <Col lg="12">
                <div className="copyright text-center text-lg-center text-muted">
                  © {new Date().getFullYear()}{" "}
                  <a
                    className="font-weight-bold ml-1 text-danger"
                    href="https://www.goliveconsultoria.com.br"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Golive Consultoria
                  </a>
                  <span className="ml-2" title={`Front buildado em ${appVersion.builtAt} (commit ${appVersion.commit})${this.state.backCommit ? ` | Back commit ${this.state.backCommit}` : ""}`}>
                    - Front {appVersion.versao}{this.state.backVersion ? ` - Back ${this.state.backVersion}` : ""}
                  </span>
                </div>
              </Col>
            </Row>
          </footer>
        </Container>
      </>
    );
  }
}

export default Calendar;
